<template lang="pug">
  section
    FinanceMasterImport(
      backUrlPath="/tms/management/base-distance"
      :uploadFileUrl="getUploadFileUrl"
      :uploadValidationUrl="getUploadValidationUrl"
      :commit-import-url="getCommitImportUrl"
      :fetchWorkListUrl="fetchWorkListUrl"
      :target-count-url="fetchWorkListCountUrl"
      :uploaded-at-action="uploadedAtAction"
      :isFilterError="isFilterError"
      :toggleFilterAction="toggleFilter"
    )
      template(v-slot:table)
        BaseDistanceImportWorkListTable(ref="WorkTable" :getListActionName="getListActionName" :isFilterError="isFilterError")
</template>

<script>
import BaseDistanceImportWorkListTable from "@/components/management/base-distance/BaseDistanceImportWorkListTable";
import FinanceMasterImport from "@/components/import/FinanceMasterImport";
import AxiosBase from "@/assets/js/axios-base";
import { mapActions, mapGetters } from "vuex";

let axiosBase = new AxiosBase();

export default {
  components: {
    BaseDistanceImportWorkListTable,
    FinanceMasterImport
  },
  methods: {
    ...mapActions("financeImport", {
      uploadFile: "uploadImportFile",
      commitImport: "commitImport",
      clearWorkData: "clearWorkData",
      fetchWorkList: "fetchWorkList",
      toggleErrorOnly: "toggleErrorOnly"
    }),
    uploadedAtAction() {
      this.toggleErrorOnly(false);
      this.$refs.WorkTable.loadUploadData();
    },
    toggleFilter() {
      this.toggleErrorOnly(!this.isFilterError);
      this.$refs.WorkTable.loadUploadData();
    }
  },
  computed: {
    ...mapGetters("financeImport", {
      isFilterError: "isFilterError"
    }),
    getListActionName: () => "financeImport/fetchWorkList",
    getUploadFileUrl: () => axiosBase.getUrls().uploadBaseDistanceImportWork,
    getUploadValidationUrl: () => axiosBase.getUrls().uploadBaseDistanceImportWorkValidation,
    getCommitImportUrl: () => axiosBase.getUrls().uploadBaseDistanceImportWorkCommit,
    fetchWorkListUrl: () => axiosBase.getUrls().getBaseDistanceWorkList,
    fetchWorkListCountUrl: () => axiosBase.getUrls().getBaseDistanceWorkListCount
  }
};
</script>
